import SuggestEditErrorResponse from './SuggestEditErrorResponse';

export default SuggestEditErrorResponse;
